var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.appLoading)?_c('LoaderComp'):_vm._e(),(!_vm.appOnline)?_c('div'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }